import DeleteIcon from "@mui/icons-material/Delete";
import { Paper } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import TablePaginationCompo from "../../components/Comman/TablePaginationCompo";
import ProductsAccordion from "../../components/Scheme/ProductsAccordion";
import endpoint from "../../config/endpoints";
import { areYouSureMsg, changeActive, deleteConfirmMsg, deleteFailedMsg, deletemsg, noInternetMsg, statusFailedMsg, statusmsg } from "../../config/messageconstant";
import { getOfferGetAll } from "../../Slice/offer.slice";
import { apiDelete, apiPost } from "../../utils/api_service";
import { useClientPagination } from "../../utils/useClientPagination";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { cloudyIndigoColor, slightBluishTintColor, white, whiteStrongShadeColor } from "../../config/ColorObj";
import AreaDetailsPopup from "./AreaDetailsPopUp";
import "./SchemeList.css";


const SchemeList = ({
    showLoador,
    getOfferGetAll,
    showNotification,
}) => {

    const navigate = useNavigate();

    const [expandedRow, setExpandedRow] = useState(null);
    const [offerList, setOfferList] = useState([]);
    const [searchValue, setSeachValue] = React.useState("");

    const [areaPopupOpen, setAreaPopupOpen] = React.useState(false);
    const [selectedAreas, setSelectedAreas] = React.useState([]);

    const [expandedSlab, setExpandedSlab] = useState(null);


    const toggleSlabProducts = useCallback((slabId) => {
        setExpandedSlab(prev => (prev === slabId ? null : slabId));
    }, []);

    const mapProducts = (products = []) =>
        Array.isArray(products) ? products.map(p => p.productName) : [];

    const toggleRow = useCallback((index) => {
        setExpandedRow(prev => (prev === index ? null : index));
    }, []);

    const fetchData = useCallback(async () => {
        if (navigator.onLine) {

            showLoador({ loador: true });
            await getOfferGetAll().then(({ response, success }) => {
                if (success) {
                    setOfferList(response);
                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }, [getOfferGetAll, showLoador, showNotification]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const addScheme = () => {
        navigate("/scheme");
    }

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const filteredTableData = useMemo(() => {
        if (!searchValue?.trim()) return offerList;

        const search = searchValue.trim().toLowerCase();

        return offerList.filter((row) => {
            const searchableFields = [
                row?.name,
                row?.typeToShowInTable,
                row?.statusValueToShowInTable,
                row?.isPanIndiaToShowInTable,
                row?.period,
            ];

            return searchableFields.some(
                (field) =>
                    field &&
                    field.toString().toLowerCase().includes(search)
            );
        });
    }, [offerList, searchValue]);

    const {
        page,
        rowsPerPage,
        pagedRows,
        count,
        handlePageChange,
        handleRowsPerPageChange,
    } = useClientPagination(filteredTableData, searchValue);

    useEffect(() => {
        setExpandedRow(null);
        setExpandedSlab(null);
    }, [page, rowsPerPage, searchValue]);

    const onDelete = useCallback(async (row) => {
        if (navigator.onLine) {
            showLoador({ loador: true });
            await apiDelete({
                url: endpoint.offer + "/" + row.id,
            }).then(async ({ success }) => {
                if (success) {
                    showNotification({ msg: deletemsg });
                    await fetchData();
                } else {
                    showNotification({
                        msg: deleteFailedMsg,
                        severity: "error",
                    });
                }
            });
            showLoador({ loador: false });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }, [fetchData, showLoador, showNotification]);

    const rowDelete = useCallback((row) => {
        if (navigator.onLine) {
            swal({
                title: areYouSureMsg,
                text: deleteConfirmMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    onDelete(row);
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }, [onDelete, showNotification]);

    const updateStatusApi = useCallback((row) => {

        if (navigator.onLine) {
            if (row.timeFlag != 2 && row.timeFlag != 3) {
                swal(changeActive, {
                    buttons: ["Cancel", true],
                }).then(async (value) => {
                    if (value) {
                        showLoador({ loador: true });
                        let status = row.timeFlag == 1 ? 0 : 1;
                        await apiPost({
                            url:
                                endpoint.offer +
                                "/update-status?id=" +
                                row.id +
                                "&status=" +
                                status,
                        }).then(async ({ data, success }) => {
                            if (success) {
                                showNotification({ msg: statusmsg });

                                await fetchData();

                            } else {
                                showNotification({ msg: statusFailedMsg, severity: "error" });
                            }
                        });
                        showLoador({ loador: false });
                    }
                });
            }
        } else {
            showNotification({
                msg: noInternetMsg,
                severity: "error",
            });
        }
    }, [fetchData, showLoador, showNotification]);

    const parseAreaNames = (areaNames = "") =>
        areaNames
            ? areaNames.split(",").map(a => a.trim()).filter(Boolean)
            : [];

    const tableRows = useMemo(() => {
        if (pagedRows.length === 0) {
            return [
                <tr key="scheme-list-empty">
                    <td
                        colSpan={8}
                        className="offer-table-empty"
                        style={{ color: slightBluishTintColor }}
                    >
                        No records found.
                    </td>
                </tr>,
            ];
        }

        return pagedRows.map((item, index) => {
            const slabRows = item.offerSlabWiseData.length !== 0 && expandedRow === index
                ? item.offerSlabWiseData.map((detailObj, dIndex) => (
                    <tr key={dIndex} className="expand-row">
                        <td colSpan="8">
                            <div className="details">
                                <div className="slab-summary-row">
                                    <Detail label="Slab No" value={dIndex + 1} />
                                    <Detail
                                        label={detailObj.valueType == 0 ? "Quantity" : "Value"}
                                        value={
                                            (detailObj.valueType == 0
                                                ? detailObj.minValue
                                                : detailObj.minValue.toFixed(2)) +
                                            " - " +
                                            (detailObj.valueType == 0
                                                ? detailObj.maxValue
                                                : detailObj.maxValue.toFixed(2))
                                        }
                                    />
                                    <Detail label="Discount (%)" value={detailObj.discount} />
                                    <Detail
                                        label="Period"
                                        value={detailObj.fromDate + "  To  " + detailObj.toDate}
                                    />
                                </div>
                                <div className="slab-product-row">
                                    <ProductsAccordion
                                        inclusiveProducts={mapProducts(detailObj.inclusiveProducts)}
                                        exclusiveProducts={mapProducts(detailObj.exclusiveProducts)}
                                        isOpen={expandedSlab === detailObj.id}
                                        onToggle={() => toggleSlabProducts(detailObj.id)}
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                ))
                : [];

            return (
                <React.Fragment key={index}>
                    <tr
                        className="main-row"
                        onClick={() => toggleRow(index)}
                    >
                        <td
                            className="scheme-sr-no"
                            style={{ color: cloudyIndigoColor }}
                        >
                            {page * rowsPerPage + index + 1}
                        </td>
                        <td>
                            <strong>{item.name}</strong>
                            <br />
                            <span className="sub">{item.typeToShowInTable}</span>
                        </td>
                        <td>{item.offerForName}</td>
                        <td>
                            <span
                                className={
                                    `statusValueToShowInTable ${item.statusValueToShowInTable === "InActive" ? "in-active" :
                                        item.statusValueToShowInTable === "Upcoming" ? "upcoming" :
                                            item.statusValueToShowInTable === "Past" ? "past" : "active"}`
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    updateStatusApi(item);
                                }}
                            >
                                {item.statusValueToShowInTable}
                            </span>
                        </td>
                        <td>
                            <span
                                className={`isPanIndiaToShowInTable ${item.isPanIndia == 1 ? "panIndia" : "areaWise"}`}
                                style={{ cursor: item.isPanIndia == 0 ? "pointer" : "default" }}
                                onClick={(e) => {
                                    if (item.isPanIndia == 0) {
                                        e.stopPropagation();
                                        setSelectedAreas(parseAreaNames(item.areaNames));
                                        setAreaPopupOpen(true);
                                    }
                                }}
                                title={item.isPanIndia == 0 ? "Click to view areas" : ""}
                            >
                                {item.isPanIndia == 0
                                    ? `Area Wise (${parseAreaNames(item.areaNames).length})`
                                    : item.isPanIndiaToShowInTable}
                            </span>
                        </td>
                        <td>{item.period}</td>
                        <td>{item.insertDateTime.split(" ")[0]}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                            <div className="actions">
                                <span
                                    className="icon delete"
                                    title="Delete"
                                    onClick={() => rowDelete(item)}
                                >
                                    <DeleteIcon fontSize="small" />
                                </span>
                            </div>
                        </td>
                    </tr>
                    {slabRows}
                </React.Fragment>
            );
        });
    }, [
        expandedRow,
        expandedSlab,
        page,
        pagedRows,
        rowDelete,
        rowsPerPage,
        toggleRow,
        toggleSlabProducts,
        updateStatusApi,
    ]);

    return (
        <>
            <Paper
                sx={{
                    padding: 2,
                }}
                elevation={0}
                className="scheme-list"
            >

                <div
                    className="header-wrapper">
                    <LandingScreenHeader
                        screenTitle="Scheme List"
                        showAddButton={false}
                        showBackButton={false}
                    />

                    <button
                        className="add-btn"
                        onClick={addScheme}>
                        Add Scheme
                    </button>
                </div>

                <LandingScreenHeader
                    screenTitle={""}
                    showSearchBox={true}
                    showTable={true}
                    showFilter={false}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    onSearch={onSearchValue}
                />

                <div
                    className="scheme-list-table-card"
                    style={{
                        borderColor: whiteStrongShadeColor,
                        backgroundColor: white,
                    }}
                >
                <div className="table-wrapper">
                    <table className="offer-table">
                        <thead>
                            <tr>
                                <th>Sr.No.</th>
                                <th>Scheme Name</th>
                                <th>Scheme For</th>
                                <th>Status</th>
                                <th>Scope</th>
                                <th>Period</th>
                                <th>Offer Created On</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableRows}
                        </tbody>
                    </table>
                </div>

                <TablePaginationCompo
                    attached
                    count={count}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />
                </div>

                {areaPopupOpen && selectedAreas.length > 0 && (
                    <AreaDetailsPopup
                        open={areaPopupOpen}
                        areas={selectedAreas}
                        title="Applicable Areas"
                        onClose={() => setAreaPopupOpen(false)}
                    />
                )}
            </Paper >
        </>
    );
};

const Detail = ({ label, value, type = "text" }) => {
    if (type === "list" && (!Array.isArray(value) || value.length === 0)) {
        return null;
    }

    return (
        <div className={`detail-box ${type === "list" ? "detail-box-list" : ""}`}>
            <label>{label}</label>
            {type === "list" ? (
                <div className="detail-list-scroll">
                    {value.map((item, index) => (
                        <span key={index} className="detail-chip">
                            {item}
                        </span>
                    ))}
                </div>
            ) : (
                <span>{value}</span>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
    showLoador,
    showNotification,
    getOfferGetAll,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
})(SchemeList);
